import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _extends from '@babel/runtime/helpers/extends';
import { getValidChildren } from '@chakra-ui/react-utils';
import { forwardRef, omitThemingProps, useMultiStyleConfig, StylesProvider, chakra, useStyles, Link, useBreakpointValue } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';
import { Pen } from '../../icons/Pen.js';

var _excluded = ["children"];

/**
 * Card
 *
 * React component used to display information in a box-ed in card-like layout.
 */
var Card = /*#__PURE__*/forwardRef(function (props, ref) {
  var rest = omitThemingProps(props);
  var styles = useMultiStyleConfig('Card', props);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref
  }, rest, {
    className: cx('chakra-card', props.className),
    __css: styles.card
  })));
});
Card.displayName = 'Card';
var CardHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(chakra.header, _extends({
    ref: ref
  }, props, {
    className: cx('chakra-card__header', props.className),
    __css: styles.header
  })));
});
CardHeader.displayName = 'CardHeader';

/**
 * Card header addon
 */
var CardHeaderAddon = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    __css: styles.headerAddon,
    size: "sm",
    ref: ref
  }, props, {
    className: cx('chakra-card__addon', props.className)
  }));
});
CardHeaderAddon.displayName = 'CardHeaderAddon';

/**
 * Card header edit button
 */
var CardHeaderEditButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children;
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(Link, _extends({
    as: "button",
    sx: styles.headerEditButton,
    ref: ref,
    className: cx('chakra-card__headerEditButton', props.className)
  }, props), /*#__PURE__*/React.createElement(Pen, {
    mr: 1
  }), children);
});
CardHeaderAddon.displayName = 'CardHeaderAddon';
var CardBody = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(chakra.div, _extends({
    ref: ref
  }, props, {
    className: cx('chakra-card__body', props.className),
    __css: styles.body
  }));
});
CardBody.displayName = 'CardBody';
var CardFooter = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useStyles();

  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var size = useBreakpointValue({
    base: 'sm',
    md: 'md'
  }, 'base'); // Add appropriate `size` to children elements.

  var validChildren = getValidChildren(children).map(function (element) {
    var _element$props;

    if (element !== null && element !== void 0 && (_element$props = element.props) !== null && _element$props !== void 0 && _element$props.size) return element;
    return /*#__PURE__*/React.cloneElement(element, {
      size: size
    });
  });
  return /*#__PURE__*/React.createElement(chakra.footer, _extends({
    ref: ref
  }, rest, {
    className: cx('chakra-card__footer', props.className),
    __css: styles.footer,
    children: validChildren
  }));
});
CardFooter.displayName = 'CardFooter';

export { Card, CardBody, CardFooter, CardHeader, CardHeaderAddon, CardHeaderEditButton };
//# sourceMappingURL=index.js.map
